import { render } from "./edit-customer.vue?vue&type=template&id=26c28ede"
import script from "./edit-customer.vue?vue&type=script&lang=js"
export * from "./edit-customer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__